module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Heart-c96de2a9b28bf86c52e35fe0b2180f41.svg";